// put style here
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export default makeStyles((theme: Theme) =>
  createStyles({
    marginTop: {
      marginTop: 15,
    },
    flexContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      alignItems: 'center',
      width: '100%',
    },
    textInputContainer: {
      width: '100%',
    },
    customTextField: {
      borderRadius: theme.spacing(1),
      width: '100%',
      '& .MuiOutlinedInput-root': {
        border: '1px solid #ccc',
        '&:hover': {
          border: '1px solid #ccc',
        },
      },
      '& input::placeholder': {
        color: '#9799B1 !important',
        fontSize: '14px !important',
        opacity: 1,
      },
      '& .MuiInputBase-input::placeholder': {
        color: '#9799B1 !important',
        fontSize: '14px !important',
        opacity: 1,
      },
    },
    questionFormTitle: {
      fontFamily: 'Poppins',
      fontSize: 22,
      fontStyle: 'normal',
      fontWeight: 700,
      color: theme.palette.primary.light,
    },
    error: {
      '& .MuiOutlinedInput-root': {
        border: `1px solid ${theme.palette.error.main}`,
      },
    },
    responseError: {
      color: `${theme.palette.error.main}`,
    },
    imageContainer: {
      width: '100%',
      marginTop: theme.spacing(2),
    },
    loaderContainer: {
      width: '100%',
      height: 200,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: '#f5f5f5',
      borderRadius: theme.spacing(1),
    },
    imagePreviewContainer: {
      width: 300,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    imagePreview: {
      width: 300,
      height: 226,
      objectFit: 'cover',
    },
    videoContainer: {
      marginTop: theme.spacing(2)
    },
    videoPreviewContainer: {
      width: 400,
      height: 'auto',
      [theme.breakpoints.down('sm')]: {
        width: '100%',
        height: 'auto',
        maxHeight: 200,
      },
    },
    formInput: {
      width: '10%',
      fontSize: 14,
      '& div fieldset': {
        borderColor: '#0E1247',
      },
      '& div input': {
        paddingTop: 12,
        paddingBottom: 12,
      },
    },
  })
);
